import { __decorate } from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import Map from '@blade-sxp/map/2d/src/Map';
import generateData, { getBlankRoi, ROI_TRANSPARENT, ROI_FILL, ROI_BORDER_TRANSPARENT, ROI_BORDER } from '@blade/common-ui/map-old/2d/src/utils/layerData';
import { Prop, Watch, Emit } from 'vue-property-decorator';
import { convertMeasurement, DeviceMap, generateImageData, generatePersonData, reconvertLocation, convertLocation, generateTrackMarkData } from '@blade/common-ui/map-old/2d/src/utils/tools';
import { find, forEach, some } from 'lodash';
import { DEVICE_COLLECTION, PERSON_COLLECTION, DEVICE_ID, PERSON_ID, MapSate, ROI_COLLECTION, ZONE_ID, HOTAREA_COLLECTION } from '@blade/common-ui/map-old/2d/src/config/mapConfig';
import { EventBus, EventKeys } from '@blade/common';
import highlight from '@blade/common-ui/map-old/2d/src/assets/highlight.png';
import { addEvents } from '@blade/common-ui/map-old/2d/src/utils/map-event-handler';
import geometryDrawer from '@blade/common-ui/geometry-drawer/src/pages/geometry-drawer.vue';
import { generateCollectionImgData, generateLayerData, generateBgcCollectionData, generateCollectionHeatMapData } from '@blade/common-ui/map-old/2d/src/utils/mapCollectionUtils';
/*
 待跟进遗留问题
 - 地图拖拽
 - roi鼠标移入高亮效果
 - ROI中心点或鼠标位置的获取
*/
let default_1 = class default_1 extends Vue {
    map;
    rootLayerData;
    deviceCollectionID = '';
    roiCollectionID = '';
    personCollectionID = '';
    imageSize = null;
    actualSize = null;
    state = null;
    deviceToAdd = null;
    personToAdd = null;
    geometryDrawerVisible = false;
    zoneInDraw = null;
    type = '';
    className = 'on-location';
    mapCoordinatesPictureData = [];
    backgroundURL;
    deviceList;
    hotAreaList;
    personList;
    zoneListLinked;
    customedEvents;
    onEndDrawCalLBack;
    modifyMode;
    collectionsData;
    mapId;
    showOption;
    details;
    onPersonListChange(nv) {
        // if (!nv || !this.map?._layer) return;
        const collectionType = PERSON_COLLECTION;
        const collectionItems = nv;
        const mapSize = this.imageSize;
        if (this.map && mapSize) {
            const collectionSource = {
                name: collectionType,
                visible: true,
                children: collectionItems,
            };
            this.updateCollection(collectionType, collectionSource, mapSize);
        }
    }
    onCollectionsDataChange(nv) {
        // console.log('onCollectionsDataChange', nv);
        if (!nv || !this.map?._layer)
            return;
        const mapSize = this.imageSize;
        Object.keys(nv).forEach((collectionType) => {
            const collectionSource = nv[collectionType];
            const isWatch = collectionSource?.isWatch ?? false;
            if (isWatch && this.map && mapSize) {
                this.updateCollection(collectionType, collectionSource, mapSize);
            }
        });
    }
    changeType(val) {
        if (val === 'device') {
            this.className = 'on-location';
        }
        if (val === 'person') {
            this.className = 'on-location-duty';
        }
    }
    onChangeMapId(nv) {
        // console.log('changeMap', nv);
        this.resetMap();
    }
    // @Watch('zoneListLinked')
    // onChangeMapZoneList(nv: string) {
    // // console.log('changeMap', nv);
    //   this.resetMap();
    // }
    //  @Watch('backgroundURL')
    // onChangeMapUrl(nv: string) {
    // // console.log('changeMap', nv);
    //   this.resetMap();
    // }
    onShowOptionChange(newOption) {
        const roi = find(this.map.getLayerData().children, item => item.props.name === ROI_COLLECTION) || {};
        roi.children?.forEach((item) => {
            this.map.updateProps(item.props.id, 'polygon', newOption.hotspot ? ROI_FILL : ROI_TRANSPARENT);
            this.map.updateProps(item.props.id, 'border', newOption.hotspot ? ROI_BORDER : ROI_BORDER_TRANSPARENT);
            this.map.updateProps(item.props.id, 'roiText', { ...item.props.roiText, color: newOption.hotspot ? '#ffffff66' : '#ffffff00' });
        });
        const camera = find(this.map.getLayerData().children, item => item.props.name === DEVICE_COLLECTION) || {};
        this.map.updateProps(camera.props.id, 'visible', newOption.camera);
        // this.getRoiPoint(this.map.getLayerData());
    }
    _initMapListener() {
        this.map.addEventListener('mapMouseDown', (e) => {
            this.customedEvents?.mapClick && this.customedEvents.mapClick(e);
        });
    }
    created() {
        this.map = null;
        this.rootLayerData = null;
    }
    async mounted() {
        const mapRef = this.$refs.mapRef;
        try {
            // console.log('this.backgroundURL', this.backgroundURL);
            this.imageSize = await convertMeasurement(this.backgroundURL);
            this.map = new Map(mapRef);
            this.map.onload = () => {
                this.$emit('onload', this.map);
            };
            this._initMapListener();
            this.setLayerData();
        }
        catch (_) {
            // console.log('try(error)==>', _);
        }
    }
    setLayerData() {
        if (!this.map)
            return;
        let layerData;
        const mapSize = this.imageSize;
        addEvents(this);
        // console.log(this.map.getPanEnabled());
        // console.log('deviceList', this.deviceList);
        layerData = generateData(this.backgroundURL, mapSize, this.deviceList, this.personList, this.zoneListLinked, this.hotAreaList, this.details);
        this.getRoiPoint(layerData);
        this.allowDrag();
        // console.log('回显roi', layerData);
        this.map.setLayerData(layerData);
        this.addCollectionsData();
        // console.log('getLayerData', this.map.getLayerData());
        const deviceCollection = find(layerData.children, ({ props }) => props?.name === DEVICE_COLLECTION);
        this.deviceCollectionID = deviceCollection?.props?.id;
        const roiCollection = find(layerData.children, ({ props }) => props?.name === ROI_COLLECTION);
        this.roiCollectionID = roiCollection?.props?.id;
        const personCollectionID = find(layerData.children, ({ props }) => props?.name === PERSON_COLLECTION);
        this.personCollectionID = personCollectionID?.props?.id;
        this.addEvents();
        this.onShowOptionChange(this.showOption);
        const changeMouse = this.customedEvents?.changeMouse;
        changeMouse && changeMouse(false);
    }
    // 重置map
    async resetMap() {
        if (!this.map) {
            const mapRef = this.$refs.mapRef;
            this.imageSize = await convertMeasurement(this.backgroundURL);
            this.map = new Map(mapRef);
        }
        else {
            // console.log(this.map.getLayerData());
            // const children = this.map.getLayerData().children || [];
            // children.map((item)=> {
            //   if(item.props.mame==='DEVICE_COLLECTION') {
            //     const child = item.children;
            //     child.map((ix)=> {
            //       if(ix.name === 'trackMark' && ix.htmlDom) {
            //           ix.htmlDom.remove();
            //       }
            //     })
            //     this.map.delCollection(item.props.id)
            //   }
            // })
            // // this.onRemoveAllMarkPoints();
        }
        let layerData = this.map.getLayerData();
        // this.map.clearLayer();
        // console.log("layerData",layerData)
        if (layerData) {
            layerData.children = [];
        }
        this.allowDrag();
        this.map.setLayerData(layerData);
        this.setLayerData();
    }
    allowDrag() {
        // 右键左右拖拽
        this.map?.setTransformMouseButtons({
            RIGHT: Map.MOUSE.PAN
        });
    }
    addCollectionsData() {
        // const mapSize = this.imageSize;
        // const bgcCollection: ICollection = generateBgcCollectionData(this.backgroundURL, mapSize);
        // const deviceCollection: ICollection = mapDevice(this.deviceList, mapSize);
        // layerData = generateLayerData([bgcCollection]);
        if (!this.collectionsData || !this.map)
            return;
        const collectionsData = this.collectionsData;
        const mapSize = this.imageSize;
        const layerData = this.map.getLayerData();
        const layerId = layerData?.props?.id;
        Object.keys(collectionsData).forEach((collectionType) => {
            const collectionSource = collectionsData[collectionType];
            const collectionData = generateCollectionImgData(collectionSource, mapSize);
            this.map.addCollection(layerId, collectionData);
        });
    }
    getTempLayerData() {
        const collectionType = PERSON_COLLECTION;
        const collection = this.personList;
        const collectionSource = {
            name: collectionType,
            visible: true,
            children: collection,
        };
        const mapSize = this.imageSize;
        const imgCollection = generateCollectionImgData(collectionSource, mapSize);
        const bagcCollection = generateBgcCollectionData(this.backgroundURL, mapSize);
        return generateLayerData([bagcCollection, imgCollection]);
    }
    updateCollection(collectionType, collection, mapSize) {
        if (!this.map)
            return;
        const layerData = this.map.getLayerData();
        let collectionData;
        if (collectionType === 'heatMap') {
            collectionData = generateCollectionHeatMapData(collection, mapSize);
        }
        else {
            collectionData = generateCollectionImgData(collection, mapSize);
        }
        const collectionId = this.findCollectionIdByType(collectionType, layerData);
        // console.log(collectionType, 99, collectionId, 'layerData', layerData, 'updateCollection collectionData', collectionData);
        try {
            // this.map.updateProps(collectionId, 'children', collectionData.children);
            if (collectionId) {
                this.map.updateCollectionChildren(collectionId, collectionData.children);
            }
            else if (!collectionId && collectionType === 'heatMap') {
                this.map.addCollection(layerData.props.id, collectionData);
            }
        }
        catch (_) { }
    }
    findCollectionIdByType(collectionType, layerData) {
        let id = '';
        try {
            const collection = layerData.children.filter((i) => (i?.props?.collectionType === collectionType))[0];
            id = collection?.props?.id;
        }
        catch (er) {
            console.log(er);
        }
        return id;
    }
    moveToPoint({ x, y, duration = 1000 }) {
        const { x: pointX, y: pointY } = convertLocation(x, y, this.imageSize);
        this.map.moveToPoint({ x: pointX, y: pointY, duration });
    }
    getRoiPoint(data) {
        const roi = find(data.children, item => item.props.name === ROI_COLLECTION) || {};
        const mapDomRef = this.$refs.mapRef;
        const { left, top } = mapDomRef.getBoundingClientRect();
        let roiList = [];
        roi.children.forEach((item) => {
            let points = [];
            item.props.points.forEach((item) => {
                const { x, y } = this.map.mapPositionToOffset(item[0], item[1]);
                points.push([left + x, top + y]);
            });
            roiList.push({ ...item.props, points });
        });
        const hotArea = find(data.children, item => item.props.name === HOTAREA_COLLECTION) || {};
        hotArea.children.forEach((item) => {
            let points = [];
            item.props.points.forEach((item) => {
                const { x, y } = this.map.mapPositionToOffset(item[0], item[1]);
                points.push([left + x, top + y]);
            });
            roiList.push({ ...item.props, points });
        });
        EventBus.$emit('ROI_LIST', roiList, this);
    }
    beforeDestroy() {
        EventBus.$off(EventKeys.MAP_ZOOM, this.onZoom);
        EventBus.$off(EventKeys.MAP_ADD_DEVICE, this.onAddDevice);
        EventBus.$off(EventKeys.MAP_ADD_MARK_POINT, this.onAddMarkPoint);
        EventBus.$off(EventKeys.MAP_REMOVE_MARK_POINTS, this.onRemoveMarkPoints);
        EventBus.$off(EventKeys.MAP_REMOVE_ALL_MARK_POINTS, this.onRemoveAllMarkPoints);
        EventBus.$off(EventKeys.MAP_ADD_PERSON, this.onAddPerson);
        EventBus.$off(EventKeys.MAP_REMOVE_DEVICE, this.onRemoveDevice);
        EventBus.$off(EventKeys.MAP_HIGHLIGHT_DEVICE, this.onHighlight);
        EventBus.$off(EventKeys.MAP_REMOVE_PERSON, this.onRemovePerson);
        EventBus.$off(EventKeys.MAP_REMOVE_ROIS, this.onRemoveRois);
        // EventBus.$off(EventKeys.MAP_HIGHLIGHT_PERSON, this.onHighlight);
        EventBus.$off(EventKeys.MAP_DRAW_ROI, this.onDraw);
        EventBus.$off(EventKeys.MAP_MOVETO_POINT, this.moveToPoint); // 地图移动到某个点
        EventBus.$off(EventKeys.MAP_REMOVE_ROI, this.onDrawRemove);
        this.map?.dispose();
    }
    getDeviceCollection() {
        const deviceCollection = find(this.rootLayerData.children, ({ props }) => props?.name === DEVICE_COLLECTION);
        return deviceCollection?.children;
    }
    // getTrackMarkCollection() {
    //   console.log(this.rootLayerData.children);
    //   const deviceCollection = find(this.rootLayerData.children, ({ props }:any) => props?.name === DEVICE_COLLECTION) as any;
    //   return deviceCollection?.children;
    // }
    getPersonCollection() {
        const deviceCollection = find(this.rootLayerData.children, ({ props }) => props?.name === PERSON_COLLECTION);
        return deviceCollection?.children;
    }
    getROICollection() {
        const deviceCollection = find(this.rootLayerData.children, ({ props }) => props?.name === ROI_COLLECTION);
        return deviceCollection?.children;
    }
    addEvents() {
        EventBus.$on(EventKeys.MAP_ZOOM, this.onZoom);
        EventBus.$on(EventKeys.MAP_ADD_DEVICE, this.onAddDevice);
        EventBus.$on(EventKeys.MAP_ADD_PERSON, this.onAddPerson);
        EventBus.$on(EventKeys.MAP_REMOVE_DEVICE, this.onRemoveDevice);
        EventBus.$on(EventKeys.MAP_REMOVE_PERSON, this.onRemovePerson);
        EventBus.$on(EventKeys.MAP_HIGHLIGHT_DEVICE, this.onHighlight);
        EventBus.$on(EventKeys.MAP_DRAW_ROI, this.onDraw);
        EventBus.$on(EventKeys.MAP_ADD_MARK_POINT, this.onAddMarkPoint);
        EventBus.$on(EventKeys.MAP_REMOVE_MARK_POINTS, this.onRemoveMarkPoints);
        EventBus.$on(EventKeys.MAP_REMOVE_ALL_MARK_POINTS, this.onRemoveAllMarkPoints);
        EventBus.$on(EventKeys.MAP_MOVETO_POINT, this.moveToPoint); // 地图移动到某个点
        EventBus.$on(EventKeys.MAP_REMOVE_ROIS, this.onRemoveRois);
        EventBus.$on(EventKeys.MAP_REMOVE_ROI, this.onDrawRemove);
        // console.log('this', this);
        // // this.$el.dispatch({ type: 'test' }, () => {
        // //   console.log(123);
        // // });
    }
    onZoom(option) {
        const layerData = this.map.getLayerData();
        const layerProps = layerData?.props;
        const propsId = layerProps.id;
        let zoom = layerProps?.zoom;
        const minZoom = layerProps?.minZoom;
        const maxZoom = layerProps?.maxZoom;
        const defaultZoom = layerProps?.defaultZoom;
        if (option > 0) {
            zoom++;
            if (zoom > maxZoom)
                zoom = maxZoom;
        }
        else if (option === 0) {
            zoom = defaultZoom;
        }
        else {
            zoom--;
            if (zoom < minZoom)
                zoom = minZoom;
        }
        layerProps.zoom = zoom;
        this.map.updateProps(propsId, 'zoom', zoom);
    }
    onDraw(zoneInDraw) {
        // console.log('画出的roi信息', zoneInDraw);
        this.geometryDrawerVisible = true;
        this.zoneInDraw = zoneInDraw;
    }
    onRemoveRois(roiList) {
        const Rois = this.getROICollection();
        const RoiMap = {};
        Rois.map((roi) => {
            const label = roi?.props?.[ZONE_ID];
            if (label) {
                RoiMap[label] = roi?.props.id;
            }
        });
        roiList?.map((roi) => {
            if (RoiMap[roi]) {
                this.map.delElement(RoiMap[roi]);
            }
        });
    }
    onRemoveMarkPoints(pointList) {
        const deviceElementList = this.getDeviceCollection();
        const deviceSet = new Set();
        deviceElementList.map((device) => {
            deviceSet.add(device.props.id);
        });
        this.map?.removeLabel();
        pointList?.map((point) => {
            if (deviceSet.has(`trackMark${point}`)) {
                this.map.delElement(`trackMark${point}`);
            }
        });
        this.map?.refreshElements();
    }
    onRemoveAllMarkPoints() {
        const deviceElementList = this.getDeviceCollection();
        deviceElementList.map((device) => {
            if (device.props.type === 'trackMark') {
                this.map?.delElement(device.props.id);
                this.map?.refreshElements();
                this.map?.delCollection();
            }
        });
    }
    onAddMarkPoint({ device, vertices, htmlDom }) {
        const { id } = device;
        const { width, height } = this.map.getMapSize();
        const data = generateTrackMarkData(id, vertices, { width, height }, htmlDom);
        this.map.addElement(this.deviceCollectionID, data);
    }
    onAddDevice({ device, vertices }) {
        const map = this.map;
        console.log(map);
        const { id, status } = device;
        this.state = null;
        this.deviceToAdd = null;
        const imgaeData = generateImageData(id, status, vertices, this.imageSize, device);
        this.map.addElement(this.deviceCollectionID, imgaeData);
    }
    onAddPerson({ person, vertices }) {
        // console.log(person);
        const { id } = person;
        this.personToAdd = null;
        this.state = null;
        const imgaeData = generatePersonData(id, vertices, this.imageSize, person);
        this.map.addElement(this.personCollectionID, imgaeData);
    }
    onRemoveDevice(deviceIdList) {
        const deviceElementList = this.getDeviceCollection();
        forEach(deviceElementList, (item) => {
            const elementID = item?.props?.id;
            const shouldRemove = some(deviceIdList, deviceId => item?.props[DEVICE_ID] === deviceId);
            if (shouldRemove) {
                this.map.delElement(elementID);
            }
        });
    }
    onRemovePerson(personIdList) {
        const deviceElementList = this.getPersonCollection();
        forEach(deviceElementList, (item) => {
            const elementID = item?.props?.id;
            const shouldRemove = some(personIdList, personId => item?.props[PERSON_ID] === personId);
            if (shouldRemove) {
                this.map.delElement(elementID);
            }
        });
    }
    onDrawRemove(id) {
        const roiCollection = find(this.rootLayerData.children, ({ props }) => props?.name === ROI_COLLECTION);
        const element = find(roiCollection?.children, item => item?.props?.[ZONE_ID] === id);
        element && this.map.delElement(element?.props?.id);
    }
    onHighlight(device, on) {
        if (this.state === MapSate.OnLocation) {
            return;
        }
        const deviceElementList = this.getDeviceCollection();
        const element = find(deviceElementList, item => item?.props[DEVICE_ID] === device.id);
        if (on) {
            this.map.updateProps(element?.props?.id, 'url', highlight);
        }
        else {
            this.map.updateProps(element?.props?.id, 'url', DeviceMap[device.status]);
        }
    }
    onEndDraw(geoType, pointsOffset) {
        if (pointsOffset.length === 0) {
            this.closeDrawer();
            return;
        }
        switch (geoType) {
            case 'polygon': {
                const { name, id } = this.zoneInDraw;
                const roiData = getBlankRoi(name, id);
                let vertices = [];
                pointsOffset.forEach(point => {
                    const { x, y } = this.map.clientToMapPosition(point.x, point.y); // x,y map组件的坐标系
                    roiData.props.points.push([x, y, 0]);
                    vertices.push(reconvertLocation(x, y, this.imageSize)); // 需要转, 传给后端的是比例
                });
                this.closeDrawer();
                this.onEndDrawCalLBack && this.onEndDrawCalLBack({ zoneId: id, roi: { vertices, name: name } }).then(() => {
                    this.map.addElement(this.roiCollectionID, roiData);
                });
                break;
            }
            case 'line':
                break;
        }
    }
    polygonsToMap(data, name, id) {
        const roiData = getBlankRoi(name, id);
        let vertices = [];
        if (data && this.map) {
            data.forEach(item => {
                item.vertices.forEach(point => {
                    const { x, y } = this.map.clientToMapPosition(point.x, point.y);
                    roiData.props.points.push([x, y, 0]);
                    vertices.push(reconvertLocation(x, y, this.imageSize)); // 需要转, 传给后端的是比例
                });
            });
            this.mapCoordinatesPictureData = vertices;
            this.map.addElement(this.roiCollectionID, roiData);
        }
    }
    getMapInstance() {
        return this.map;
    }
    closeDrawer() {
        this.geometryDrawerVisible = false;
    }
    onClickElement(o) {
        return o;
    }
};
__decorate([
    Prop()
], default_1.prototype, "backgroundURL", void 0);
__decorate([
    Prop()
], default_1.prototype, "deviceList", void 0);
__decorate([
    Prop()
], default_1.prototype, "hotAreaList", void 0);
__decorate([
    Prop()
], default_1.prototype, "personList", void 0);
__decorate([
    Prop()
], default_1.prototype, "zoneListLinked", void 0);
__decorate([
    Prop()
], default_1.prototype, "customedEvents", void 0);
__decorate([
    Prop()
], default_1.prototype, "onEndDrawCalLBack", void 0);
__decorate([
    Prop()
], default_1.prototype, "modifyMode", void 0);
__decorate([
    Prop()
], default_1.prototype, "collectionsData", void 0);
__decorate([
    Prop()
], default_1.prototype, "mapId", void 0);
__decorate([
    Prop()
], default_1.prototype, "showOption", void 0);
__decorate([
    Prop({ default: false })
], default_1.prototype, "details", void 0);
__decorate([
    Watch('personList', { deep: true })
], default_1.prototype, "onPersonListChange", null);
__decorate([
    Watch('collectionsData', { deep: true })
], default_1.prototype, "onCollectionsDataChange", null);
__decorate([
    Watch('type', { immediate: true })
], default_1.prototype, "changeType", null);
__decorate([
    Watch('mapId')
], default_1.prototype, "onChangeMapId", null);
__decorate([
    Watch('showOption', { deep: true })
], default_1.prototype, "onShowOptionChange", null);
__decorate([
    Emit('onClickElement')
], default_1.prototype, "onClickElement", null);
default_1 = __decorate([
    Component({
        name: 'map-util',
        components: { geometryDrawer }
    })
], default_1);
export default default_1;
